// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../../../types';

import gql from 'graphql-tag';
export type HasPreferredVenueContentWrapperProposalFragment = { __typename?: 'Proposal', hasPreferredVenue: boolean };

export const HasPreferredVenueContentWrapperProposalFragmentDoc = gql`
    fragment HasPreferredVenueContentWrapperProposal on Proposal {
  hasPreferredVenue
}
    `;